class importSettingCtrl {
    constructor($rootScope, $scope) {
        // 初始化表单数据
        // 用户信息
        const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
        }
    }
}

importSettingCtrl.$inject = ['$rootScope', '$scope']
export default importSettingCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/importSetting/importSettingCtrl.js